module.exports = __webpack_public_path__ + "img/ruStore.1511f209.svg";